import { Injectable } from '@angular/core';

import { RouteConstants } from '../../../app/constants/route.constants';
import { DemoAccountService } from '../../../app/services/demo-account.service';
import { NavigationService } from '../../../app/services/navigation.service';

@Injectable({
    providedIn: 'root',
})
export class DemoSignupGuard  {
    constructor(private navigationService: NavigationService, private demoAccountService: DemoAccountService) {}

    canActivate(): boolean {
        if (this.demoAccountService.hasSignedUp()) {
            return true;
        } else {
            this.navigationService.navigateToRoute(RouteConstants.HOME);
            return false;
        }
    }
}
